export default "__VITE_ASSET__a045d706__"